var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import contService from "@/core/services/contService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Plano_Contas_TipoActions } from "@/store/enums/ContEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Plano_Contas_TipoModule = class Plano_Contas_TipoModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Plano_Contas_TipoActions.POST_PLANO_CONTAS_TIPO](data) {
        return new Promise(resolve => {
            contService.post("Plano_Contas_Tipo/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Plano_Contas_TipoActions.PUT_PLANO_CONTAS_TIPO](data) {
        return new Promise(resolve => {
            contService.put("Plano_Contas_Tipo/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Plano_Contas_TipoActions.DELETE_PLANO_CONTAS_TIPO](data) {
        return new Promise(resolve => {
            contService.delete("Plano_Contas_Tipo/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Plano_Contas_TipoActions.DELETE_RANGE_PLANO_CONTAS_TIPO](data) {
        return new Promise(resolve => {
            contService.delete("Plano_Contas_Tipo/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Plano_Contas_TipoActions.FILTER_PLANO_CONTAS_TIPO](data) {
        return new Promise(resolve => {
            contService.post("Plano_Contas_Tipo/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Plano_Contas_TipoActions.GET_PLANO_CONTAS_TIPO]() {
        return new Promise(resolve => {
            contService.get("Plano_Contas_Tipo/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Plano_Contas_TipoActions.GETWITHDISABLED_PLANO_CONTAS_TIPO]() {
        return new Promise(resolve => {
            contService.get("Plano_Contas_Tipo/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Plano_Contas_TipoActions.GET_BY_ID_PLANO_CONTAS_TIPO](data) {
        return new Promise(resolve => {
            contService.get("Plano_Contas_Tipo/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Plano_Contas_TipoModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Plano_Contas_TipoModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Plano_Contas_TipoModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Plano_Contas_TipoModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Plano_Contas_TipoModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Plano_Contas_TipoModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Plano_Contas_TipoModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Plano_Contas_TipoModule.prototype, _h, null);
Plano_Contas_TipoModule = __decorate([
    Module
], Plano_Contas_TipoModule);
export default Plano_Contas_TipoModule;
//# sourceMappingURL=Plano_Contas_TipoModule.js.map